import { Buffer } from "buffer";

import { AuthKitProvider } from "@farcaster/auth-kit";
import { RemixBrowser, useLocation, useMatches } from "@remix-run/react";
import * as Sentry from "@sentry/remix";
import { ethers } from "ethers";
import { startTransition, StrictMode, useEffect } from "react";
import { hydrateRoot } from "react-dom/client";

Sentry.init({
  dsn: "https://2a1e900e31d5257c3739a0ff7e9e3e72@o4507419293974528.ingest.us.sentry.io/4507419303084032",
  tracesSampleRate: 1,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1,

  integrations: [
    Sentry.browserTracingIntegration({
      useEffect,
      useLocation,
      useMatches,
    }),
    // eslint-disable-next-line import/namespace
    Sentry.replayIntegration(),
  ],
});

const { VITE_DOMAIN, VITE_LOGIN_URL } = import.meta.env;

globalThis.Buffer = Buffer;

const authConfig = {
  rpcUrl: "https://mainnet.optimism.io",
  domain: VITE_DOMAIN,
  siweUri: VITE_LOGIN_URL,
  relay: "https://relay.farcaster.xyz",
  provider: new ethers.JsonRpcProvider(undefined, 10),
};

startTransition(() => {
  hydrateRoot(
    document,
    <StrictMode>
      <AuthKitProvider config={authConfig}>
        <RemixBrowser />
      </AuthKitProvider>
    </StrictMode>,
  );
});
